module.exports = __webpack_public_path__ + "img/scannerSave_01.058e36c9.png";